export const NAV_LINKS = [
  { label: "Home", href: "#home", icon: "fa-solid fa-house" },
  { label: "Services", href: "#services", icon: "fa-solid fa-layer-group" },
  { label: "Why Us", href: "#why", icon: "fa-solid fa-star" },
  { label: "Clients", href: "#clients", icon: "fa-solid fa-handshake" },
  { label: "Contact", href: "#contact", icon: "fa-solid fa-paper-plane" },
];
